import type { ReactNode } from 'react';

export const symbol_modeling: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m684-265 55 57q8.25 8.8 8.63 20.9.37 12.1-8.84 21.1-9.22 9-21.5 9-12.29 0-21.29-9L590-273q-9-9.27-9-21.64 0-12.36 9-21.36l107-107q9-9 21-9t20.5 9q8.5 9 9 21t-8.5 21l-55 56 166 1q12 0 21 8.62 9 8.63 9 21.38 0 12.75-8.5 21.37Q863-264 850-264l-166-1ZM140-160q-24 0-42-18t-18-42v-147q0-24 18-42t42-18h269q24 0 42 18t18 42v147q0 24-18 42t-42 18H140Zm0-60h269v-147H140v147Zm136-417H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-697 110-697h166l-55-56q-8.25-8.8-8.62-20.9Q212-786 221-795q9-9 21-9t21 9l107 107q9 9 9 21t-9 21L263-538q-9 9-21 9t-21-9q-8-8-8.5-20.5T220-580l56-57Zm275 104q-24 0-42-18t-18-42v-147q0-24 18-42t42-18h269q24 0 42 18t18 42v147q0 24-18 42t-42 18H551Zm0-60h269v-147H551v147ZM409-220v-147 147Zm142-373v-147 147Z"
		/>
	</svg>
);
